import { FunctionComponent } from 'react'
import * as S from './styled'
import { EggIcon } from './EggIcon'

type OwnProps = {
  text: string
  bgColor: string
  type: string
}

type Props = OwnProps

const NameBox: FunctionComponent<Props> = ({ text, bgColor, type }) => {
  return <S.Container bgColor={bgColor}>{text === '' ? <EggIcon type={type} /> : text}</S.Container>
}

export default NameBox
